import type { TourShow } from '../domain/models'

export const tourShows: readonly TourShow[] = [
  {
    id: 'show-01',
    sequence: 1,
    city: 'Dallas',
    region: 'TX',
    venue: 'Northline Hall',
    isoDate: '2026-10-14T19:00:00-05:00',
    dateLabel: 'OCT 14',
    doorsLabel: 'DOORS 7:00 PM',
    showStatus: 'check-in-open',
    headline: 'Dallas, you are up.',
    update: 'Check-in is open. Save your pass before you reach the door.',
    checkInOpen: true,
  },
  {
    id: 'show-02',
    sequence: 2,
    city: 'Austin',
    region: 'TX',
    venue: 'Circuit Room',
    isoDate: '2027-10-17T19:30:00-05:00',
    dateLabel: 'OCT 17',
    doorsLabel: 'DOORS 7:30 PM',
    showStatus: 'upcoming',
    headline: 'Next stop: Austin.',
    update: 'Set times will land here when the show-day board opens.',
    checkInOpen: false,
  },
  {
    id: 'show-03',
    sequence: 3,
    city: 'Atlanta',
    region: 'GA',
    venue: 'Switchyard',
    isoDate: '2026-11-18T19:00:00-05:00',
    dateLabel: 'NOV 18',
    doorsLabel: 'DOORS 7:00 PM',
    showStatus: 'upcoming',
    headline: 'Atlanta joins the route.',
    update: 'Save this stop to keep venue notes and arrival reminders together.',
    checkInOpen: false,
  },
  {
    id: 'show-04',
    sequence: 4,
    city: 'Nashville',
    region: 'TN',
    venue: 'Backline Works',
    isoDate: '2027-10-24T18:30:00-05:00',
    dateLabel: 'OCT 24',
    doorsLabel: 'DOORS 6:30 PM',
    showStatus: 'upcoming',
    headline: 'Nashville after dark.',
    update: 'Your saved plans, community posts, and ticket status travel with you.',
    checkInOpen: false,
  },
  {
    id: 'show-05',
    sequence: 5,
    city: 'Chicago',
    region: 'IL',
    venue: 'Lake Street Assembly',
    isoDate: '2027-10-29T19:00:00-05:00',
    dateLabel: 'OCT 29',
    doorsLabel: 'DOORS 7:00 PM',
    showStatus: 'upcoming',
    headline: 'Chicago is on deck.',
    update: 'Build your night plan now and adjust it whenever the board changes.',
    checkInOpen: false,
  },
  {
    id: 'show-06',
    sequence: 6,
    city: 'Denver',
    region: 'CO',
    venue: 'Highline Garage',
    isoDate: '2027-11-02T19:30:00-07:00',
    dateLabel: 'NOV 02',
    doorsLabel: 'DOORS 7:30 PM',
    showStatus: 'upcoming',
    headline: 'Denver, mark the wall.',
    update: 'Connect a pass to unlock the show-day check-in card.',
    checkInOpen: false,
  },
  {
    id: 'show-07',
    sequence: 7,
    city: 'Los Angeles',
    region: 'CA',
    venue: 'Static House',
    isoDate: '2027-11-07T19:00:00-08:00',
    dateLabel: 'NOV 07',
    doorsLabel: 'DOORS 7:00 PM',
    showStatus: 'upcoming',
    headline: 'Los Angeles lights the board.',
    update: 'Follow the city feed for Fits, Merch, Scene, and arrival notes.',
    checkInOpen: false,
  },
  {
    id: 'show-08',
    sequence: 8,
    city: 'Seattle',
    region: 'WA',
    venue: 'Rain City Terminal',
    isoDate: '2027-11-11T19:00:00-08:00',
    dateLabel: 'NOV 11',
    doorsLabel: 'DOORS 7:00 PM',
    showStatus: 'upcoming',
    headline: 'Last mark: Seattle.',
    update: 'Save the stop to pin it to your itinerary and passport route.',
    checkInOpen: false,
  },
] as const

// New fan accounts begin in the band's home city so the first ticket and
// community journey are immediately relevant to The Paradox.
export const defaultShowId = tourShows.find((show) => show.city === 'Atlanta')?.id
  ?? tourShows[0]?.id
  ?? 'show-03'
